import {gsap} from "gsap";
import {SimplePresentation, SimplePresentationRunnerController} from "../SimplePresentationRunner";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {ScatterSymbol} from "../reels/symbols/ScatterSymbol";
import {SymbolStates} from "../reels/symbols/BasicSymbol";

export class ScatterWinPresentation implements SimplePresentation {
    name: string = "ScatterWinPresentation";
    private _scatterWintl: gsap.core.Timeline;

    shouldRun(): boolean {
        return XwaysHoarder2.model.isFreespinStarting || XwaysHoarder2.model.isSuperFreespinStarting;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._scatterWintl = gsap.timeline({
            onComplete: () => {
                controller.finish();
            }
        });

        this._scatterWintl.to(this, {duration: 0.05});

        if (XwaysHoarder2.model.gameData) {
            if (XwaysHoarder2.model.gameData.betWayWins.length > 0) {
                XwaysHoarder2.reelView.hideReelsNoWinOverlay();
            }
        }

        let startTime: number = 1;
        if (XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL3" || (XwaysHoarder2.model.isFreespinStarting && XwaysHoarder2.model.gameData.betWayWins.length > 0)) {
            this._scatterWintl.to(this, {duration: startTime}, 0);
        }
        let count: number = 0;
        XwaysHoarder2.model.scatterLandedPos.forEach((symPos: number, reelIndex: number) => {
            if (symPos > -1) {
                let scatterSym: ScatterSymbol = <ScatterSymbol>XwaysHoarder2.reelView.reels[reelIndex].model.getVisibleSymbolAt(symPos).positionable;
                this._scatterWintl.add(scatterSym.getStateAnimation(SymbolStates.WIN), count === 0 ? startTime  : "<0.25");
                count++;
            }
        });

        this._scatterWintl.to(this, {duration: 0.05});
        controller.setSkipCallback(() => {});
    }

}